import { render, staticRenderFns } from "./AddCard.vue?vue&type=template&id=63c93e7a"
import script from "./AddCard.vue?vue&type=script&lang=js"
export * from "./AddCard.vue?vue&type=script&lang=js"
import style0 from "./AddCard.vue?vue&type=style&index=0&id=63c93e7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports